export const GET_CLUB_SIGNUP_REQUEST = 'GET_CLUB_SIGNUP_REQUEST';
export const GET_CLUB_SIGNUP_REQUESTING = 'GET_CLUB_SIGNUP_REQUESTING';
export const GET_CLUB_SIGNUP_SUCCESS = 'GET_CLUB_SIGNUP_SUCCESS';
export const UPDATE_CLUB_SIGNUP_REQUEST = 'UPDATE_CLUB_SIGNUP_REQUEST';
export const RESET_CLUB_SIGNUP_ISFETCHING = 'RESET_CLUB_SIGNUP_ISFETCHING';
export const UPDATE_CLUB_SIGNUP_WITH_PASSWORD_AND_PROCESS_REQUEST =
  'UPDATE_CLUB_SIGNUP_WITH_PASSWORD_AND_PROCESS_REQUEST';
export const CREATE_CLUB_SIGNUP_REQUEST = 'CREATE_CLUB_SIGNUP_REQUEST';
export const UPDATE_AND_PROCESS_CLUB_SIGN_UP_REQUEST =
  'UPDATE_AND_PROCESS_CLUB_SIGN_UP_REQUEST';
export const CLUB_SIGNUP_STEP_REQUEST_GTM = 'CLUB_SIGNUP_STEP_REQUEST_GTM';
export const CLUB_SIGNUP_STEP_REQUEST = 'CLUB_SIGNUP_STEP_REQUEST';
export const CHARGE_CLUB_SIGNUP_SUCCESS_GTM = 'CHARGE_CLUB_SIGNUP_SUCCESS_GTM';
export const UPDATE_CLUB_SIGNUP_WITH_PASSWORD_REQUEST =
  'UPDATE_CLUB_SIGNUP_WITH_PASSWORD_REQUEST';
export const SEND_CLUB_SIGNUP_TO_HOSTED_PAYMENT_REQUEST =
  'SEND_CLUB_SIGNUP_TO_HOSTED_PAYMENT_REQUEST';
export const GET_CLUB_SIGNUP_HOSTED_PAYMENT_REQUEST =
  'GET_CLUB_SIGNUP_HOSTED_PAYMENT_REQUEST';
